var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',{attrs:{"aria-label":_vm.$t('architecturalRequests.title'),"role":"region"}},[_c('ModernTable',{attrs:{"region":_vm.region,"filters":_vm.filters,"rows":_vm.rows,"columns":_vm.columns,"pagination":{
      perPage: 12
    },"loading":_vm.loading,"onUpdate":_vm.updateTable,"headerColor":"#FFF","condensed":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }